import React from "react";

interface DocumentLibraryPreviewPopinProps {
  title: string;
  kindLabel?: string;
  fileName?: string;
  viewer: React.ReactNode;
  openUrl?: string | null;
  downloadUrl?: string | null;
  openDocumentLabel?: string;
  downloadLabel?: string;
}

export default function DocumentLibraryPreviewPopin({
  title,
  kindLabel,
  fileName,
  viewer,
  openUrl,
  downloadUrl,
  openDocumentLabel,
  downloadLabel,
}: DocumentLibraryPreviewPopinProps) {
  return (
    <div className="DocumentLibraryPreviewPopin-content">
      <div className="DocumentLibraryPreviewPopin-header">
        <div className="DocumentLibraryPreviewPopin-copy">
          <h2 className="DocumentLibraryPreviewPopin-title">{title}</h2>
          {kindLabel ? <p className="DocumentLibraryPreviewPopin-meta">{kindLabel}</p> : null}
        </div>
        {fileName ? <p className="DocumentLibraryPreviewPopin-file">{fileName}</p> : null}
      </div>
      {viewer}
      {(openUrl && openDocumentLabel) || (downloadUrl && downloadLabel) ? (
        <div className="DocumentLibraryPreviewPopin-actions">
          {openUrl && openDocumentLabel ? (
            <a
              href={openUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="Button DocumentLibraryDetailActions-secondary"
            >
              {openDocumentLabel}
            </a>
          ) : null}
          {downloadUrl && downloadLabel ? (
            <a href={downloadUrl} className="Button">
              {downloadLabel}
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
